import {IDotRezUserSessionCodesSettingsResponse} from "../../data-contracts/responses/user-session-codes-settings.response";
import {UserSessionClassesOfService} from "./user-session-classes-of-service";

export class UserSessionCodesSettings {
    constructor(codesSettings: IDotRezUserSessionCodesSettingsResponse) {
        this.classesOfService = new UserSessionClassesOfService(codesSettings.classOfServices);
    }

    readonly classesOfService: UserSessionClassesOfService;
}